import { KeyValuePair } from '@core/models';

export const errorStrings: KeyValuePair[] = [
  {
    key: 'server_connect_failure',
    value:
      'There was a problem connecting to the server.  Please try again in a few minutes.',
  },
];
